import { render } from "./NovusDashboard.vue?vue&type=template&id=756232f8"
import script from "./NovusDashboard.vue?vue&type=script&lang=js"
export * from "./NovusDashboard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/novus-cloud-ui/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__